const routePath = {
    default: '/',
    home: '/',
    chat: '/chat'
};

export default routePath;
